module.exports = __webpack_public_path__ + "static/img/john_peroid.b7c1849.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/john_peroid.jpg
// module id = w9KN
// module chunks = 1